import { Outlet, Link } from "react-router-dom";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { WhatsAppButton } from "@/components/layout/WhatsAppButton";
import { AIConcierge } from "@/components/AIConcierge";
import { waLink } from "@/constants/site";
import { track } from "@/lib/api";

export function Layout() {
  return (
    <div className="App min-h-screen bg-[#080808] overflow-x-hidden">
      <Navbar />
      <main className="pt-[68px] pb-16 lg:pb-0">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
      <AIConcierge />

      {/* Mobile bottom action bar */}
      <div className="lg:hidden fixed bottom-0 inset-x-0 z-30 flex items-stretch h-14 border-t border-[#C9A45C]/20 bg-[#080808]/95 backdrop-blur-md" data-testid="mobile-action-bar">
        <Link to="/consultation" data-testid="mobile-sticky-cta"
          className="flex-1 flex items-center justify-center bg-[#C9A45C] text-black text-[13px] font-semibold tracking-wide">
          BOOK CONSULTATION
        </Link>
        <a href={waLink()} target="_blank" rel="noopener noreferrer" onClick={() => track("whatsapp_click", { location: "mobile-bar" })}
          data-testid="mobile-whatsapp" className="w-14 flex items-center justify-center bg-[#25D366]" aria-label="WhatsApp">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="#0A0A0A"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884" /></svg>
        </a>
      </div>
    </div>
  );
}
